import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

import { getFormatMedia } from "~/theme/utils";

import { STORE_CAROUSEL_CLASSES } from "./constants";

export const StoreCarouselContainer = styled(Box)(({ theme }) => {
  const formatMedia = getFormatMedia(theme);
  return {
    transition: "margin 300ms",
    [formatMedia.BREAKPOINT_DESKTOP]: {
      display: "none",
    },
    [`& .${STORE_CAROUSEL_CLASSES.elementWrapper}`]: {
      height: "100%",
    },
    [`& .${STORE_CAROUSEL_CLASSES.element}`]: {
      width: "76%",
      marginLeft: theme.spacing(2),
      [formatMedia.BREAKPOINT_TABLET]: {
        width: "41%",
        marginLeft: theme.spacing(3),
        "&:first-of-type": {
          marginLeft: theme.spacing(4),
        },
      },
      "&:last-of-type": {
        marginRight: theme.spacing(2),
        [formatMedia.BREAKPOINT_TABLET]: {
          marginRight: theme.spacing(3),
        },
      },
    },
    [`& .${STORE_CAROUSEL_CLASSES.elements}`]: {
      "& .swiper-wrapper": {
        alignItems: "stretch",
        height: "auto !important",
      },
    },
  };
});
